<template lang="pug">
.padding.p-t-0
    report-filter(
        @onOutletChange="applyOutletFilter",
        @onDateChange="applyDateFilter"
    )
        template(slot="title") Stock Request

    .row
        .col-xs-12
            .box
                v-server-table(
                    :url="api",
                    :name="tableName",
                    :columns="columns",
                    :options="options",
                    ref="datatable"
                )
                    template(slot="status" slot-scope="props")
                        span.label.blue-grey(v-if="props.row.status == 0") Open
                        span.label.danger(v-if="props.row.status == 1") Rejected
                        span.label.yellow(v-if="props.row.status == 2") Waiting Approval
                        span.label.info(v-if="props.row.status == 3") Approved
                        span.label.green(v-if="props.row.status == 4") Received
</template>

<script>
const TableName = 'VUETABLE_STOCK_REQUEST';
const exportUrl = 'stock_requests.export_stock_request_list';
const APPROVED = 3;

export default {
    data() {
        var that = this;

        return {
            tableName: TableName,
            columns: [
                'reference_id',
                'name',
                'request_from_outlet',
                'request_to_outlet',
                'preferred_stock_transfer_date',
                'request_stocks',
                'status',
            ],
            options: {
                columnsClasses: {
                    request_stocks: 'text-center',
                },
                permission: {
                    create: () => this.permission.SAVE_STOCK_REQUEST,
                    delete: () => this.permission.DELETE_STOCK_REQUEST,
                },
                checkbox: {
                    delete_title: 'Delete Stock Request',
                    api_delete: Laroute.route('stock_requests.mass-delete'),
                },
                csv_url: Laroute.route(exportUrl, { type: 'CSV' }),
                pdf_url: Laroute.route(exportUrl, { type: 'PDF' }),
                xls_url: Laroute.route(exportUrl, { type: 'XLSX' }),
                create_btn: {
                    title: 'New Stock Request',
                    action: () => {
                        that.showCreateForm();
                    },
                },
                customFilters: ['outlet_id', 'since', 'until'],
                initFilters: {
                    outlet_id: this.$store.getters.activeOutlet,
                },
                headings: {
                    preferred_stock_transfer_date: 'Preferred Transfer Date',
                    request_from_outlet: 'Source Outlet',
                    request_to_outlet: 'Destination Outlet',
                    stock_request_products: 'Request Stocks',
                },
                orderBy: {
                    ascending: false,
                    column: 'reference_id',
                },
                rowClassCallback: row => 'pointer',
                rowClickCallback: that.showForm,
                templates: {
                    preferred_stock_transfer_date(h, row) {
                        return this.formattedDate(
                            row.preferred_stock_transfer_date,
                        );
                    },
                },
                checkboxDisableCallback: row => {
                    return row.status >= APPROVED;
                },
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('stock_requests.index');
        },
    },
    methods: {
        showForm(row) {
            this.$router.push(`/${row.id}`);
        },

        showCreateForm() {
            this.$router.push('/create');
        },

        applyOutletFilter(outlet) {
            this.$refs.datatable.applyOutletFilter(outlet);
        },

        applyDateFilter(date) {
            this.$refs.datatable.applyDateFilter(date);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_request/stock-request-list.vue